import { render } from "./IconCash.vue?vue&type=template&id=32cbbf5e"
import script from "./IconCash.vue?vue&type=script&lang=js"
export * from "./IconCash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconCash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32cbbf5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32cbbf5e', __exports__)) {
    api.reload('32cbbf5e', __exports__)
  }
  
  module.hot.accept("./IconCash.vue?vue&type=template&id=32cbbf5e", () => {
    api.rerender('32cbbf5e', render)
  })

}


export default __exports__